var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg"},[_c('div',{staticClass:"inner",style:({width: _vm.comWidth})}),_c('div',{staticClass:"tip"},[_vm._v("上传中"+_vm._s(_vm.comWidth))])])}
var staticRenderFns = []

export { render, staticRenderFns }